import { useEffect, useRef } from "react";
import * as Sentry from "@sentry/react";
import { Carrusel } from "./Carrusel";
import { ListaBanners } from "@/hooks/useHome";
import { Categories } from "./Categories";

export const Banner = () => {
  const banners = ListaBanners();
  // "Vacío confirmado": la query ya resolvió (no está isFetching), no falló
  // (no está isError) y el backend devolvió una lista sin banners. Distinto
  // de "cargando", donde aún no sabemos si habrá banners y conviene reservar
  // el alto completo (--banner-h) para evitar layout shift, y distinto de
  // "error", que antes producía el mismo DOM que "no hay banners" — por eso
  // esta regresión llegó a QA sin ninguna señal (HTTP 200, lista vacía, sin
  // error en consola ni en Sentry). En el caso confirmado no tiene sentido
  // dejar el hueco completo permanentemente, así que se agrega .banner-vacio
  // para que #bannerPrincipal use un --banner-h reducido (ver App.css) sin
  // volver a solapar las categorías con la navbar.
  const hasBanners = Array.isArray(banners?.data) && banners.data.length > 0;
  const isEmptyConfirmed =
    Boolean(banners) && !banners?.isFetching && !banners?.isError && !hasBanners;

  // Reportar el "200 vacío" a Sentry — una sola vez por montaje — porque hoy
  // no deja ningún rastro observable y es exactamente el tipo de fallo
  // silencioso que produjo el bug de "carrusel desaparecido en QA".
  const reportedRef = useRef(false);
  useEffect(() => {
    if (isEmptyConfirmed && !reportedRef.current) {
      reportedRef.current = true;
      Sentry.captureMessage("Home: listarBanners devolvió lista vacía", {
        level: "warning",
        tags: { endpoint: "listarBanners" },
      });
    }
  }, [isEmptyConfirmed]);

  return (
    <div
      id="bannerPrincipal"
      className={`container-fluid${isEmptyConfirmed ? " banner-vacio" : ""}`}
      style={{ width: "98%" }}
    >
      {/* <div className="d-flex align-content-center justify-content-center">
        <img className="img-fluid" src={imgBanner} alt="Banner" />
      </div> */}

      <Carrusel list={banners} />
      <Categories />
    </div>
  );
};
